export enum CouponStatus {
    OVERDUED = "VENCIDO",
    OVERCOME = "PENDIENTE",
}
